/**
 * True when the page was opened with `?embed=true` (iframe / TechDocs / wiki).
 * Read from `window.location` because the app shell is outside the page router.
 */
export const isEmbedMode = (): boolean => {
  try {
    return new URLSearchParams(window.location.search).get('embed') === 'true';
  } catch {
    return false;
  }
};

/**
 * Hides the sidebar and the navy gutter SidebarPage keeps for it.
 * The drawer is `position: fixed`; the blue strip is `padding-left` plus the
 * navy `BackstageSidebarPage` background, so hiding the drawer alone is not enough.
 */
export const EMBED_MODE_CSS = `
  [data-embed-mode="true"] nav[aria-label="sidebar nav"],
  [data-embed-mode="true"] [data-testid="sidebar-root"],
  [data-embed-mode="true"] [data-testid="mobile-sidebar-root"] {
    display: none !important;
  }
  [data-embed-mode="true"] [class*="BackstageSidebarPage"] {
    padding-left: 0 !important;
    padding-bottom: 0 !important;
    background: transparent !important;
  }
`;
